"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noModifierKeysPressed = void 0;
exports.getModifierKeys = getModifierKeys;
exports.noModifierKeysPressed = { shiftKey: false, ctrlKey: false, altKey: false, metaKey: false };
function getModifierKeys(overrides = {}) {
    return { ...exports.noModifierKeysPressed, ...overrides };
}
//# sourceMappingURL=keys.js.map